// extracted by mini-css-extract-plugin
export default {"container":"MenuSiVale_container__kybYj","content":"MenuSiVale_content__aM7PJ","tab":"MenuSiVale_tab__EPiQ5","permisos":"MenuSiVale_permisos__rsAKd"};